export const getAnswer = (rawAnswer) => (Array.isArray(rawAnswer) ? rawAnswer[0] : rawAnswer);

export const formatAnswersHelpers = {
  getAnswer,
};
